export interface NotificationStatusFilterType {
  selectedNotificationStatus: server.dto.NotificationStatusFilterSettings
}

export const DefaultNotificationStatusFilter: server.dto.NotificationStatusFilterSettings = "noFilter";

export const initialNotificationStatusFilter: NotificationStatusFilterType = {
  selectedNotificationStatus: DefaultNotificationStatusFilter
};